<!-- src/app/settings/accruals/pages/leave-policy-history/leave-policy-history.component.html -->
<accruals-nav></accruals-nav>

<div class="leave-policy-history-container">
  <!-- Loading -->
  <div *ngIf="isLoading" class="spinner-container">
    <div class="spinner"></div>
  </div>

  <!-- Error -->
  <div *ngIf="errorMessage && !isLoading" class="error-message">
    {{ errorMessage }}
  </div>

  <ng-container *ngIf="!isLoading">
    <!-- Header -->
    <div class="header">
      <h2>Policy History</h2>
    </div>

    <!-- Filters -->
    <div class="filters-container">
      <div class="filters-row">
        <label class="filter-field search-field">
          <span>Search</span>
          <input
            type="text"
            [(ngModel)]="searchInputValue"
            (ngModelChange)="onSearchTermChange($event)"
            placeholder="Search employee, policy, leave type, frequency, or deleted by"
          />
        </label>

        <label class="filter-field">
          <span>Policy</span>
          <select
            [ngModel]="filters.leavePolicyId"
            (ngModelChange)="onPolicyChange($event)"
          >
            <option [ngValue]="null">All policies</option>
            <option *ngFor="let policy of allPolicies" [ngValue]="policy.id">
              {{ policy.name }}
            </option>
          </select>
        </label>

        <label class="filter-field">
          <span>Leave Type</span>
          <select
            [ngModel]="filters.leaveType"
            (ngModelChange)="onLeaveTypeChange($event)"
          >
            <option [ngValue]="null">All leave types</option>
            <option *ngFor="let type of leaveTypes" [ngValue]="type">
              {{ type }}
            </option>
          </select>
        </label>

        <label class="filter-field">
          <span>Start Date</span>
          <input
            type="date"
            [ngModel]="filters.startDate"
            (ngModelChange)="onStartDateChange($event)"
          />
        </label>

        <div class="filter-actions">
          <button
            class="clear-filters-btn"
            type="button"
            (click)="clearFilters()"
            [disabled]="!hasActiveFilters"
          >
            Clear Filters
          </button>
        </div>
      </div>
    </div>

    <!-- Sticky Pagination -->
    <div class="pagination sticky">
      <div class="page-controls">
        <button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">
          Prev
        </button>

        <span>Page {{ currentPage }} of {{ totalPages }}</span>

        <button (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages">
          Next
        </button>
      </div>

      <div class="page-size">
        <label for="pageSize">Page Size:</label>
        <select id="pageSize" [(ngModel)]="pageSize" (change)="changePageSize(pageSize)">
          <option *ngFor="let size of pageSizes" [value]="size">{{ size }}</option>
        </select>
      </div>
    </div>

    <!-- History List -->
    <div class="history-list" *ngIf="filteredHistoryRows.length > 0; else noHistory">
      <div
        *ngFor="let row of pagedHistoryRows; trackBy: trackByHistoryId"
        class="history-row"
        [ngClass]="[
          getLeaveTypeClass(row.leavePolicy.leaveType),
          row.isDeleted ? 'deleted' : ''
        ]"
      >
        <div class="history-main">
          <div class="history-top-row">
            <div class="history-top-left">
              <div class="employee-name-wrap">
                <div class="employee-name">
                  {{ row.employee.firstName }} {{ row.employee.lastName }}
                </div>

                <div class="employee-pills">
                  <span class="employee-number-badge">
                    #{{ row.employee.employeeNumber }}
                  </span>

                  <span
                    class="leave-type-badge"
                    [ngClass]="getLeaveTypeClass(row.leavePolicy.leaveType)"
                  >
                    {{ getNormalizedLeaveType(row.leavePolicy.leaveType) }}
                  </span>

                  <span class="policy-badge">
                    {{ getNormalizedAccrualFrequency(row.leavePolicy.accrualFrequency) }}
                  </span>

                  <span *ngIf="row.isDeleted" class="deleted-badge">
                    Deleted
                  </span>
                </div>
              </div>

              <div class="policy-name">
                {{ row.leavePolicy.name }}
              </div>
            </div>

            <div
              class="policy-summary-card"
              [ngClass]="[
                getLeaveTypeClass(row.leavePolicy.leaveType),
                row.isDeleted ? 'deleted' : ''
              ]"
            >
              <div class="summary-label">
                {{ getNormalizedLeaveType(row.leavePolicy.leaveType) }} Policy
              </div>
              <div class="summary-value">
                {{ row.leavePolicy.hoursPerYear }} hrs/year
              </div>
            </div>
          </div>

          <div class="history-meta">
            <span>Start Date: {{ row.startDate }}</span>
            <span *ngIf="row.nextAccrualDate">Next Accrual: {{ row.nextAccrualDate }}</span>
            <span>Max Balance: {{ row.leavePolicy.maxBalance }}</span>
            <span>Carry Over: {{ row.leavePolicy.maxCarryOver }}</span>

            <span *ngIf="row.isDeleted && row.deletedAt">
              Deleted At: {{ row.deletedAt | date: 'short' }}
            </span>

            <span *ngIf="row.isDeleted && row.deletedBy">
              Deleted By: {{ row.deletedBy.firstName }} {{ row.deletedBy.lastName }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <ng-template #noHistory>
      <div class="empty-state">
        No policy history matches the current filters.
      </div>
    </ng-template>
  </ng-container>
</div>